/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from 'react';
import Text from '../../../atoms/Text';
import './styles.scss';

/**
 * Implements a floating list of columns
 * @param props
 * @returns
 */

interface IColumnsList {
  hiddenColumnsKey: string;
  visibleColumns: any[];
  allColumns: any[];
  onHide(): void;
}

const ColumnsList = ({
  hiddenColumnsKey,
  visibleColumns,
  allColumns,
  onHide,
}: IColumnsList) => {
  useEffect(() => {
    const ids = allColumns.map((i: any) => i.id); // all: ['date', 'priceOut', 'price']
    const visIds = visibleColumns.map((i: any) => i.id); // visible: ['date', 'priceOut']
    const hidden = ids.filter((i: any) => visIds.indexOf(i) === -1); // difference: ['price']

    localStorage.setItem(hiddenColumnsKey, JSON.stringify(hidden));
  }, [visibleColumns]);

  return (
    <>
      <div className='checkbox__backdrop' onClick={onHide} />
      <div className='checkbox__dropdown'>
        {allColumns.map((column: any) => {
          const props = column.getToggleHiddenProps();
          return (
            <div key={column.id}>
              <label className='dropdown__item'>
                <input type='checkbox' {...props} />
                <div className='checkmark' />
                <Text
                  size={12}
                  className={`dropdown__item__name ${
                    column.isVisible ? 'dropdown__item__name--active' : ''
                  }`}
                >
                  {column.Header}
                </Text>
              </label>
            </div>
          );
        })}
      </div>
    </>
  );
};

export default ColumnsList;
